import { createSlice } from '@reduxjs/toolkit';
import 'firebase/compat/auth';
import history from '@history';
import _ from '@lodash';
import { setInitialSettings, setDefaultSettings } from 'app/store/fuse/settingsSlice';
import { showMessage } from 'app/store/fuse/messageSlice';
import CrmJwtService from 'app/services/crm/CrmJwtService';
import settingsConfig from 'app/fuse-configs/settingsConfig';

export const setUserData = (user) => async (dispatch, getState) => {
    /*
    You can redirect the logged-in user to a specific route depending on his role
    */
    if (user.loginRedirectUrl) {
        settingsConfig.loginRedirectUrl = user.loginRedirectUrl; // for example 'apps/academy'
    }
    /*
    Set User Settings
    */
    dispatch(setDefaultSettings(user.data.settings));

    dispatch(setUser(user));
};

export const updateUserSettings = (settings) => async (dispatch, getState) => {
    const oldUser = getState().crm.crmuser;
    const user = _.merge({}, oldUser, { data: { settings } });

    dispatch(updateUserDataSettings(user));

    return dispatch(setUserData(user));
};

export const updateUserShortcuts = (shortcuts) => async (dispatch, getState) => {
    const { crmuser } = getState().crm;
    const newUser = {
        ...crmuser,
        data: {
            ...crmuser.data,
            shortcuts,
        },
    };

    dispatch(updateUserData(newUser));

    return dispatch(setUserData(newUser));
};

export const logoutUser = () => async (dispatch, getState) => {
    const { crmuser } = getState().crm;

    if ((!crmuser.role || crmuser.role.length === 0)) {
        // is guest
        return null;
    }

    history.push({
        pathname: '/crmlogin',
    });

    CrmJwtService.logout();

    return dispatch(setInitialSettings());
};

export const updateUserData = (user) => async (dispatch, getState) => {
    CrmJwtService
        .updateUserData(user)
        .then(() => {
            dispatch(showMessage({ message: 'User data saved with api' }));
        })
        .catch((error) => {
            dispatch(showMessage({ message: error.message }));
        });
};

export const updateUserDataSettings = (user) => async (dispatch, getState) => {
    CrmJwtService
        .updateUserDataSettings(user)
        .then(() => {
            dispatch(showMessage({ message: 'User data saved with api' }));
        })
        .catch((error) => {
            dispatch(showMessage({ message: error.message }));
        });
};

const initialState = {
    role: [], // guest
    data: {
        displayName: 'John Doe',
        photoURL: 'assets/images/avatars/Velazquez.jpg',
        email: 'johndoe@withinpixels.com',
        shortcuts: ['calendar', 'mail', 'contacts', 'todo'],
    },
};

const crmUserSlice = createSlice({
    name: 'crm/user',
    initialState,
    reducers: {
        setUser: (state, action) => action.payload,
        userLoggedOut: (state, action) => initialState,
    },
    extraReducers: {},
});

export const { setUser, userLoggedOut } = crmUserSlice.actions;

export default crmUserSlice.reducer;
